import { departmentDashboard } from '../../actions/constant';

const {
  CHECK_ASSIGN_TASK_PTO_REQUEST,
  CHECK_ASSIGN_TASK_PTO_SUCCESS,
  CHECK_ASSIGN_TASK_PTO_FAILURE,
  CHECK_ASSIGN_TASK_PTO_LOADING,
  CHECK_ASSIGN_TASK_PTO_RESET,
} = departmentDashboard;

const intitialstate: object = {
  response: null,
  isCheckPTO: false,
  errorMessage: '',
  loading: false,
};

export const checkAssignTaskPTOReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CHECK_ASSIGN_TASK_PTO_SUCCESS: {
      return {
        ...state,
        isCheckPTO: true,
        response: action.payload.data,
        loading: false,
      };
    }

    case CHECK_ASSIGN_TASK_PTO_FAILURE:
      return {
        ...state,
        isCheckPTO: false,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case CHECK_ASSIGN_TASK_PTO_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CHECK_ASSIGN_TASK_PTO_RESET:
      return intitialstate;

    default:
      return state;
  }
};
